'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _angularUiRouter = require('angular-ui-router');

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _mapIngredients = require('./map-ingredients.component');

var _mapIngredients2 = _interopRequireDefault(_mapIngredients);

require('./map-ingredients.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('components.app.admin.map-ingredients', [_angularUiRouter2.default]).component('mapIngredients', _mapIngredients2.default).config(function ($stateProvider) {
  'ngInject';

  $stateProvider.state('mapIngredients', {
    parent: 'admin',
    url: '/map-ingredients',
    component: 'mapIngredients',
    resolve: {
      flex: function flex() {
        return '100';
      },
      layout: function layout() {
        return 'column';
      },
      query: function query(IngredientService) {
        return IngredientService.getDefaultUserIngredientQuery();
      },
      queryMapped: function queryMapped(IngredientService) {
        return IngredientService.getDefaultUserIngredientQuery();
      }
    }
  });
}).name;


// WEBPACK FOOTER //
// ./components/app/admin/map-ingredients/map-ingredients.module.js